import { currencies } from '../src/currencies';
export default currencies;
export type { SupportedCurrencies } from '../src/currencies';
